import { NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { RouterModule } from '@angular/router';

import { NgbActiveModal, NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';

import { environment } from '@environments';
import { ApiService } from '@services/api.service';

interface Alert {
  type: string;
  message: string;
}

@Component({
  selector: 'app-login',
  imports: [
    NgClass,
    RouterModule,
    FormsModule,
    NgbAlertModule,
    ReactiveFormsModule,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  activeModal = inject(NgbActiveModal);

  // ! FROM site request
  password: string = '';

  apiAlert: Alert | null = null;
  domain: string = '';
  loading: boolean = false;
  form!: FormGroup;

  constructor(private api: ApiService) {}

  ngOnInit(): void {
    const domain = sessionStorage.getItem(environment.storage + '-site');

    if (domain) {
      this.domain = domain;
    }

    if (this.password) {
      this.form = new FormGroup({
        store: new FormControl('', [Validators.required]),
        password: new FormControl(''),
      });
    } else {
      this.form = new FormGroup({
        store: new FormControl('', [Validators.required]),
      });
    }
  }

  submit() {
    this.apiAlert = null;

    if (this.form.invalid) {
      this.apiAlert = {
        type: 'danger',
        message: '¡Llena todos los campos!',
      };

      return;
    }

    const formValue: any = this.form.value;

    if (this.password) {
      if (formValue['password'] !== this.password) {
        this.apiAlert = {
          type: 'danger',
          message: '¡Contraseña incorrectos!',
        };

        return;
      }
    }

    this.loading = true;

    formValue['domain'] = this.domain;

    const params = {
      domain: formValue['domain'],
      store: formValue['store'],
    };

    sessionStorage.setItem(
      environment.storage + '-site-store',
      formValue['store']
    );

    this.api.call('api/site', 'post', params).subscribe({
      next: (response) => {
        if (response.status === 200) {
          this.activeModal.close(true);
        } else {
          this.apiAlert = {
            type: 'danger',
            message:
              response.message?.join(', ') ??
              '¡Ocurrio un error al iniciar sesión!',
          };
        }

        this.loading = false;
      },
      error: (error) => {
        console.error(error);
        this.apiAlert = {
          type: 'danger',
          message: error,
        };
        this.loading = false;
      },
    });
  }

  close() {
    this.apiAlert = null;
  }
}
